import { render, staticRenderFns } from "./DailySubGoalView.vue?vue&type=template&id=057bf4d6"
import script from "./DailySubGoalView.vue?vue&type=script&lang=js"
export * from "./DailySubGoalView.vue?vue&type=script&lang=js"
import style0 from "./DailySubGoalView.vue?vue&type=style&index=0&id=057bf4d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports